import styled from 'styled-components';
import IconCalendarXl from '../../../assets/icon-calendar-xl.svg';

export const SettingsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Wrapper = styled.div`
  margin-bottom: 20px;
  padding: 18px 29px 38px 29px;
  position: relative;
  overflow-x: hidden;
  background-color: #fff;
  border: 1px solid rgba(146, 156, 185, 0.5);
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  max-width: 670px;
  width: 100%;
  @media (max-width: 1023px) {
    padding: 25px 20px;
  }
  @media (max-width: 767px) {
    padding: 25px 15px;
  }
  &.w100 {
    max-width: 100%;
  }
  &.mBottom0 {
    margin-bottom: 0;
  }
  &.smPaddings {
    padding: 25px 30px;
  }
`;

export const LocationFormActions = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  top: -80px;
  right: -30px;
  @media (max-width: 1250px) {
    top: -77px;
  }
  @media (max-width: 1024px) {
    right: -24px;
  }
  @media (max-width: 767px) {
    top: -74px;
    right: -15px;
  }

  &.PublishOverlay {
    z-index: 13;

    body {
      overflow: hidden !important;
    }
  }

  .LocationFormSave {
    position: relative;
  }

  .ButtonSave {
    width: 160px;
    padding: 10px 5px;
    overflow: inherit;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    svg {
      width: 26px;
      height: 26px;
      z-index: 7;
      flex: 0 0 auto;
      @media (max-width: 599px) {
        width: 24px;
        height: 24px;
      }
    }
    span {
      padding-left: 10px;
      @media (max-width: 599px) {
        display: none;
      }
    }
    @media (max-width: 599px) {
      width: 44px;
      height: 44px;
      padding: 9px 5px;
    }
  }
`;

export const StoreDisabledBanner = styled.div`
  background-color: #fff;
  border: 1px solid rgba(146, 156, 185, 0.5);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  padding: 40px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 1.3;
  color: #2f3d48;
  max-width: 1350px;
  margin: 32px auto;
  position: relative;

  .StoreDisabledBannerRside {
    .bottomText {
      margin-top: 4px;
      @media (max-width: 767px) {
        font-size: 13px;
      }
      @media (max-width: 599px) {
        font-size: 12.5px;
        line-height: 1.1;
      }
      .LinkButton {
        @media (max-width: 767px) {
          font-size: 13px;
        }
        @media (max-width: 599px) {
          font-size: 12.5px;
        }
      }
    }
  }

  @media (max-width: 1700px) {
    font-size: 18px;
    padding: 34px 20px;
    max-width: 1080px;
  }
  @media (max-width: 1500px) {
    font-size: 17px;
    padding: 30px 18px;
    max-width: 1000px;
  }
  @media (max-width: 1400px) {
    font-size: 16px;
    padding: 28px 18px;
    max-width: 940px;
  }
  @media (max-width: 1360px) {
    padding: 24px 14px;
    max-width: 880px;
    font-size: 15px;
  }
  @media (max-width: 767px) {
    padding: 24px 18px;
    align-items: flex-start;
  }
  @media (max-width: 599px) {
    font-size: 14px;
  }
  @media (max-width: 440px) {
    font-size: 13px;
    padding: 20px 15px;
    align-items: flex-start;
  }

  &::before {
    display: inline-block;
    flex: 0 0 auto;
    margin-right: 12px;
    content: '';
    width: 48px;
    height: 48px;
    background-image: url(${IconCalendarXl});
    background-repeat: no-repeat;
    background-size: contain;
    @media (max-width: 1599px) {
      width: 40px;
      height: 40px;
    }
    @media (max-width: 1439px) {
      width: 36px;
      height: 36px;
    }
    @media (max-width: 1400px) {
      width: 34px;
      height: 34px;
    }
    @media (max-width: 1360px) {
      width: 30px;
      height: 30px;
      margin-right: 7px;
    }
    @media (max-width: 767px) {
      width: 30px;
      height: 30px;
    }
    @media (max-width: 599px) {
      width: 26px;
      height: 26px;
    }
    @media (max-width: 440px) {
      width: 22px;
      height: 22px;
    }
  }
`;

export const DatePickerString = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 18px;
  margin: 20px 0;
  @media (max-width: 550px) {
    display: block;
    padding: 0;
    margin: 20px 0 0 0;
  }
  &:last-child {
    margin-bottom: 0;
  }

  .DatePickerInner {
    flex: 0 0 auto;
    width: 100%;
    max-width: 272px;
    padding-left: 22px;

    @media (max-width: 650px) {
      width: 50%;
    }
    @media (max-width: 550px) {
      width: 100%;
    }
    .MuiFormControl-root {
      max-width: 150px;
      margin-top: 10px;
    }
  }
`;

export const SpecialHoursEntry = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  margin-top: 15px;
  background-color: #ffffff;
  border-radius: 5px;
  font-size: 14px;
  color: #2f3d48;
  box-shadow: 1px 3px 10px rgba(0, 0, 0, 0.2), 1px -1px 10px rgba(0, 0, 0, 0.2);
  .SpecialHoursText {
    span {
      color: #969ba0;
    }
  }
`;

export const StoreAvailabilityRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 24px;
  @media (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 20px;
  }
`;

export const StoreAvailabilityBlockLeft = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`;

export const StoreAvailabilityBlockTitle = styled.div`
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.3;
  color: #2f3d48;
`;

export const StoreAvailabilityBlockDesc = styled.div`
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 1.3;
  color: #929cb9;
  margin-top: 4px;
`;

export const OrderingChannelsHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

export const OrderingChannelsTitle = styled.div`
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.3;
  color: #2f3d48;
`;

export const OrderingChannelsStatus = styled.div`
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 1.3;
  color: #929cb9;
  margin-top: 4px;
`;

export const OrderingChannelsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 8px;
`;

export const OrderingChannelCard = styled.button`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 180px;
  min-height: 150px;
  padding: 20px 16px 16px;
  background: #ffffff;
  border: 1px solid rgba(146, 156, 185, 0.35);
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    border-color: rgba(255, 45, 56, 0.45);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }

  &.paused {
    border-color: rgba(255, 45, 56, 0.35);
  }
`;

export const OrderingChannelStatusDot = styled.span`
  position: absolute;
  top: 10px;
  right: 10px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #22c55e;

  &.paused {
    background: #ff2d38;
  }
`;

export const OrderingChannelIcon = styled.img`
  width: 48px;
  height: 48px;
  object-fit: contain;
  margin-bottom: 12px;
`;

export const OrderingChannelName = styled.div`
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 1.2;
  color: #2f3d48;
  text-align: center;
`;

export const OrderingChannelSubtitle = styled.div`
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 11px;
  line-height: 1.2;
  color: #ff2d38;
  margin-top: 4px;
  text-align: center;
`;

export const OrderingChannelStatusText = styled.div`
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 1.2;
  color: #22c55e;
  margin-top: 8px;
  text-align: center;

  &.paused {
    color: #ff2d38;
  }
`;

export const OrderingChannelDivider = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 20px 0 16px;
  color: #929cb9;
  font-family: 'Poppins', sans-serif;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;

  &::before,
  &::after {
    content: '';
    flex: 1 1 auto;
    height: 1px;
    background: rgba(146, 156, 185, 0.45);
  }
`;

export const OrderingChannelDividerLine = styled.div`
  width: 100%;
  height: 1px;
  margin: 20px 0 20px;
  background: rgba(146, 156, 185, 0.45);
`;

export const QrCodeHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 24px;

  > div:first-child {
    flex: 1 1 auto;
    min-width: 0;
    align-items: flex-start;

    span {
      line-height: 1.4;
    }
  }

  button {
    flex: 0 0 auto;
    white-space: nowrap;
  }

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`;

export const QrCodeDisplay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  margin: 0 auto;
  padding: 16px;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  background-color: #ffffff;

  svg {
    display: block;
  }
`;

export const MenuBannerField = styled.div`
  position: relative;
  width: 100%;

  .MenuBannerCounter {
    margin: 6px 0 0;
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 150%;
    text-align: right;
    color: #929cb9;
  }
`;

export const BillingBankHeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;

  button {
    flex: 0 0 auto;
    white-space: nowrap;
  }
`;

export const BillingBankStatusBadge = styled.span`
  background: ${(props) => (props.connected ? '#def5e7' : '#f1f3f5')};
  border-radius: 14px;
  color: ${(props) => (props.connected ? '#267247' : '#66727c')};
  font-size: 12px;
  font-weight: 600;
  padding: 5px 10px;
  white-space: nowrap;
`;

export const BillingBankAccountNumber = styled.span`
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #172751;
  white-space: nowrap;
`;

export const BillingBankDescription = styled.p`
  margin: 10px 0 0;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  line-height: 150%;
  color: #929cb9;
`;

export const SelfDeliveryReportEmailHint = styled.div`
  /* Positioned like ErrorSignWrapper so the hint doesn't affect the row height
     and the label stays vertically centered on the input, same as other rows. */
  position: absolute;
  top: calc(100% - 8px);
  left: 0;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  line-height: 150%;
  color: #667085;

  button {
    padding: 0;
    border: 0;
    background: none;
    font: inherit;
    color: #2f6fed;
    text-decoration: underline;
    cursor: pointer;

    &:disabled {
      opacity: 0.5;
      cursor: default;
    }
  }
`;
